<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
<p-toast></p-toast>
<p-fieldset>


    <ng-template pTemplate="header">{{lbl_attendance}}</ng-template>
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="{{lbl_back}}" icon="pi pi-chevron-left" class="p-button-warning p-mr-2" (click)="redirectParent()"></button>
        </ng-template>
    
        <!--<ng-template pTemplate="right">
            <p-fileUpload mode="basic" accept="image/*" [maxFileSize]="1000000" label="Import" chooseLabel="Import" class="p-mr-2 p-d-inline-block"></p-fileUpload>
            <button pButton pRipple label="Export" icon="pi pi-upload" class="p-button-help"></button>
        </ng-template>-->
    </p-toolbar>
    <div class="card">

        <div class="p-grid">
            <div class="p-col-12 p-md-6">
                <p-panel>
                    <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                        <span>{{lbl_place_where_provide}}</span>
                        <span class="p-text-bold">{{form0Detail != null ? form0Detail.churchAdress.name : ""}}</span>
                    </div>
                    <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                        <span>{{lbl_Service}}</span>
                        <span class="p-text-bold">{{form0Detail != null ? form0Detail.serName : ""}}	</span>
                    </div>
                    <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                        <span>{{lbl_schedule}}</span>
                        <span class="p-text-bold">{{form0Detail != null ? form0Detail.fromTime : ""}} - {{form0Detail != null ? form0Detail.toTime : ""}}</span>
                    </div>
                    <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                        <span>{{lbl_session}}</span>
                        <span class="p-text-bold">{{session != null  ? session.sessNum : ""}}: {{session != null  &&  session.sessDescription ? session.sessDescription : session.sessDescription1}}</span>
                    </div>
                    <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                        <span>{{lbl_date}}</span>
                        <span class="p-text-bold">{{session != null  ? session.sessDate : ""}}</span>
                    </div>
                    <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                        <span>{{lbl_total}}</span>
                        <span class="p-text-bold">{{totalAssist}}</span>
                    </div>
                   
                </p-panel>
            </div>
        </div>

        <p-table #dt [value]="listParticipantAssist" [rows]="20" [paginator]="true" [globalFilterFields]="['key.sequence','summary','startingDate']"
                [(selection)]="selectedParticipantAssist" [rowHover]="true" dataKey="particiId" styleClass="p-datatable-responsive-demo"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [showCurrentPageReport]="true" editMode="row" responsiveLayout="scroll">
                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        <h5 class="p-m-0">{{lbl_participants}}  </h5>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="{{lbl_search}}..." />
                        </span>
                    </div>
                    
                    <span class="p-input-icon-left">
                        <!--button type="button" pButton pRipple icon="pi pi-plus" (click)="createParticipant()" class="p-mr-4" pTooltip="Agregar" tooltipPosition="bottom" ></button>
                        <button type="button" pButton pRipple (click)="goBack()" class="p-mr-4" pTooltip="Regresar" tooltipPosition="bottom">Regresar</button>
                        <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()" class="p-button-success p-mr-2"  pTooltip="XLS" tooltipPosition="bottom"></button>
                        <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()" class="p-button-warning p-mr-2" pTooltip="PDF" tooltipPosition="bottom"></button-->
                    </span>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="particiId">{{lbl_id}}<p-sortIcon field="particiId"></p-sortIcon></th>
                        <th pSortableColumn="descri">{{lbl_name}}<p-sortIcon field="descri"></p-sortIcon></th>
                        <th pSortableColumn="type">{{lbl_last_name}}<p-sortIcon field="type"></p-sortIcon></th>
                        <th>Asiste</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-sesspart>
                    <tr>
                        <td>{{sesspart.participant.particiId | number}}</td>
                        <td>{{sesspart.participant.name}}</td>
                        <td>{{sesspart.participant.lastName}}</td>
                        <td >
                            <p-checkbox [(ngModel)]="sesspart.isAssist" [binary]="true" inputId="binary" (onChange)="onChangeAssist(sesspart)"></p-checkbox>
                        </td>
                    </tr>
                </ng-template>

                    <ng-template pTemplate="summary">
                        <div class="p-d-flex p-ai-center p-jc-between">
                            {{lbl_total}} {{lbl_there_are}} {{listParticipantAssist ? listParticipantAssist.length : 0 }} {{lbl_participants}}.
                        </div>
                    </ng-template>
        </p-table>

        
    </div>

</p-fieldset>